import React, { useEffect, useState } from 'react';
import Icon, { Logo } from './Icon';
import { BRAND, CONTACT_PHONE, CONTACT_PHONE_HREF } from '../site';

const LINKS = [
  ['#voice-ai', 'Voice AI'],
  ['#upselling', 'Upselling'],
  ['#languages', 'Languages'],
  ['#kiosk', 'Kiosk'],
  ['#admin', 'Admin Portal'],
  ['#faq', 'FAQ'],
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <header className={`nav${scrolled ? ' nav--scrolled' : ''}${open ? ' nav--open' : ''}`}>
      <div className="wrap nav__inner">
        <a href="#top" className="brand" onClick={close}>
          <Logo />
          <span>{BRAND}</span>
        </a>
        <nav className="nav__links" aria-label="Primary">
          {LINKS.map(([href, label]) => (
            <a key={href} href={href} onClick={close}>
              {label}
            </a>
          ))}
          <a href={CONTACT_PHONE_HREF} className="nav__mobile-phone" onClick={close}>
            <Icon name="phone" size={18} /> {CONTACT_PHONE}
          </a>
          <a href="#demo" className="btn btn--primary nav__mobile-cta" onClick={close}>
            Book a demo
          </a>
        </nav>
        <a href={CONTACT_PHONE_HREF} className="nav__phone" aria-label={`Call us at ${CONTACT_PHONE}`}>
          <Icon name="phone" size={16} /> {CONTACT_PHONE}
        </a>
        <a href="#demo" className="btn btn--primary btn--sm nav__cta">
          Book a demo
        </a>
        <button
          className="nav__toggle"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
